const EMAIL_VALIDATION_PATTERN = '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$';

export { EMAIL_VALIDATION_PATTERN }